import { useContext } from 'react';
import { context } from '../data-providers/model';

export default () => useContext(context);



// WEBPACK FOOTER //
// ./src/client/js/view/hooks/use-model.js